const editWorkout = () => {};

export default editWorkout;
